import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../Common/Button';
import { Menu, LogOut } from 'lucide-react';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user, logout } = useAuth();

  const getInitials = (nome?: string) => {
    if (!nome) return 'U';
    const parts = nome.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return nome.substring(0, 2).toUpperCase();
  };

  const getAvatarColor = (nome?: string) => {
    if (!nome) return 'bg-primary-500';
    const colors = ['bg-primary-500', 'bg-secondary-500', 'bg-success-500', 'bg-warning-500'];
    const index = nome.charCodeAt(0) % colors.length;
    return colors[index];
  };

  return (
    <header className="bg-gradient-to-r from-white to-neutral-50 shadow-md border-b border-neutral-200 h-16 fixed top-0 right-0 left-0 lg:left-64 z-20">
      <div className="h-full px-4 md:px-6 flex items-center justify-between gap-4">
        {/* Botão hamburguer para mobile */}
        <button
          onClick={onMenuClick}
          className="lg:hidden text-neutral-600 hover:text-neutral-800 p-2 -ml-2 hover:bg-neutral-100 rounded-lg transition-all duration-150"
          aria-label="Abrir menu"
        >
          <Menu className="w-6 h-6" />
        </button>

        <Link to="/perfil" className="hover:opacity-75 transition-opacity flex-1 min-w-0 flex items-center gap-3">
          <div className={`w-10 h-10 rounded-full ${getAvatarColor(user?.nome)} flex items-center justify-center text-white font-display font-bold text-sm shadow-sm`}>
            {getInitials(user?.nome)}
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-base md:text-lg font-display font-bold text-neutral-900 truncate">
              {user?.nome}
            </h2>
            <p className="text-xs md:text-sm text-neutral-600 truncate">{user?.tipo}</p>
          </div>
        </Link>

        <Button variant="secondary" size="sm" onClick={logout} className="flex-shrink-0 flex items-center gap-2">
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Sair</span>
        </Button>
      </div>
    </header>
  );
};

export default Header;
